import React, { useState } from 'react';
import classNames from 'classnames';

const TabbedSection = ({ tabs, defaultTab, children, topPadding = true, disabledTabs = [] }) => {
    const [activeTab, setActiveTab] = useState(defaultTab);

    return (
        <div className="bg-[var(--color-white)] rounded-[22px] h-full flex flex-col">
            <div
                className={classNames(
                    'flex border-b border-[var(--color-gray-100)] gap-10 mb-4 pr-10 pl-10',
                    topPadding ? 'pt-10' : ''
                )}>
                {tabs.map((tab) => {
                    const Icon = tab.icon ? tab.icon : null;

                    return (
                        <button
                            type="button"
                            key={tab.label}
                            className={classNames(
                                'tw-paragraph-lg pb-5 border-0 border-b-3 flex items-center gap-2',
                                activeTab === tab.tab
                                    ? 'border-[var(--color-blue-500)] font-semibold text-[var(--color-black)]'
                                    : 'border-transparent text-[var(--color-gray-600)]',
                                tab.showTooltip ? 'relative group' : ''
                            )}
                            onClick={() => !disabledTabs.includes(tab.tab) && setActiveTab(tab.tab)}>
                            {Icon && Icon}
                            {tab.showLabel && <span>{tab.label}</span>}
                            {tab.showTooltip && (
                                <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                                    {tab.label}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
            {children[activeTab]}
        </div>
    );
};

export default TabbedSection;
